module.exports = __webpack_public_path__ + "img/frame (272).e6a8f31a.jpg";